import { render, staticRenderFns } from "./UiSelectPro.vue?vue&type=template&id=3fccf5a0&"
import script from "./UiSelectPro.vue?vue&type=script&lang=ts&"
export * from "./UiSelectPro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports